import { isEqualCaseInsensitive } from '../../../../../shared/utils/isEqualCaseInsensitive';
import { UNITED_STATES } from '../constants/UnitedStates';

export function getStateAbbreviationForName(input: string) {
	return UNITED_STATES.find((state) =>
		isEqualCaseInsensitive(state.name, input),
	)?.abbreviation;
}
